<template>
  <div>
    <div>
      <h1>Formulário: {{ checklist.formName }}</h1>
    </div>
    <checklist-fill
      ref="teste"
      :token="this.$store.getters.token"
      :checklist="checklist"
      @finishFilling="loadData"
    >
    </checklist-fill>
    <!-- <div>{{checklist}}</div> -->
    <!-- <pre class="language-json"><code>{{ checklist  }}</code></pre> -->
  </div>
</template>
<script>
import ChecklistFill from "@/mixins/checklist/fill/ChecklistFill";
export default {
  name: "Fill",
  components: {
    ChecklistFill: () =>
      import("@/components_rms/checklist/fill/ChecklistFill.vue"),
  },
  mixins: [ChecklistFill],
  props: {
    FormId: String,
    ChecklistId: String,
  },
  data: function () {
    return {
      checklist: {
        id: 0,
        formId: 0,
        formName: "",
        draft: false,
        values: [
          {
            fieldId: 0,
            fieldName: "",
            fieldTip: "",
            fieldType: 6,
            allowsAttachment: false,
            required: false,
            value: "",
            options: null,
          },
        ],
      },
    };
  },
  mounted: function () {
    if (this.FormId == this.$store.getters.formVehicleRevisionExitId && this.ChecklistId) {
      this.loadDataExit();
    } else if (this.ChecklistId) {
      this.loadDraft();
    } else {
      this.loadData();
    }
  },
  methods: {
    async loadDraft() {
      this.checklist = await this.getChecklistById(
        this.$store.getters.token,
        this.ChecklistId
      );
      console.log("loadDraft - this.checklist");
      console.log(this.checklist);
    },
    async loadData() {
      this.checklist = await this.getChecklistNew(
        this.$store.getters.token,
        this.FormId
      );
    },
    async loadDataExit() {
      this.checklist = await this.getChecklistExitNew(
        this.$store.getters.token,
        this.$store.getters.formVehicleRevisionExitId,
        this.ChecklistId
      );
    },
  },
};
</script>
